module.exports = __webpack_public_path__ + "e01ba5d13b377d1839ee0dd166c7a36c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/partners/images/banner_bg.jpg
// module id = 966
// module chunks = 3